import React from 'react'

import {
    ContainerDefault, ContainerModal, ProgressModal, ProgressPercentage, ProgressDefault, ProgressWindow, ProgressPercentageContainer
} from './styles'
import { twMerge } from 'tailwind-merge'

export default function ({
    backgroundColor = '#388E3C', 
    label = '', 
    visible = false, 
    modal = false, 
    percentage = 0, 
    hint, 
    style, 
    rotulada = false, 
    rotulos,
    value
}) {
    if(rotulada && !!rotulos?.length && value) {
        if (!visible) {
            return null
        }

        const totalPosicoes = rotulos.length
        const step = 100 / (totalPosicoes - 1)
        const valorAtual = value * step
        const { label, color } = rotulos[value]

        return (
            <div className="h-2 w-full mb-4 mt-2 mx-2" style={{ width: 'calc(100% - 16px)' }}>
                <div className="w-full h-full">
                    <div className="bg-slate-300 w-full h-full rounded-md">
                        <div className={twMerge(`w-[${valorAtual}%] h-full rounded-md transition-all`, color)}></div>
                    </div>

                    <span className="text-xs">{label}</span>
                </div>
            </div>
        )
    }

    if (percentage !== null) {
        if (!visible) {
            return null
        }

        return (
            <ProgressPercentageContainer style={style}>
                <ProgressPercentage value={percentage} color="#FFEB3B" />

                {hint && (<p className="hint">{hint}</p>)}
            </ProgressPercentageContainer>
        )
    }

    return modal ? (
        <ContainerModal visible={visible} style={style}>
            <ProgressWindow>
                <ProgressModal mode="indeterminate" />

                <p className="progress-label">
                    {label}
                </p>
            </ProgressWindow>
        </ContainerModal>
    ) : (
        <ContainerDefault backgroundColor={backgroundColor} visible={visible} style={style}>
            <ProgressDefault mode="indeterminate" />

            <span className="progress-label">
                {label}
            </span>
        </ContainerDefault>
    )
}
